import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects (fetch / archive), not
 * state transitions (the saga owns the resulting `load*` / `archive*` ones).
 */

/** Load every administrator (dispatched by the page on mount). */
export const administratorsRequested = createAction('administrators/administratorsRequested');

/** Archive (true) or unarchive (false) a row. */
export const archiveToggleRequested = createAction<{ id: string; archived: boolean }>(
  'administrators/archiveToggleRequested',
);

/** Delete a (deactivated) administrator for good (task #587). */
export const deleteRequested = createAction<{ id: string }>('administrators/deleteRequested');

/** Count what deleting this administrator takes with them, for the dialog. */
export const deletionImpactRequested = createAction<{ id: string }>(
  'administrators/deletionImpactRequested',
);
